"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.motdepasseField = exports.emailField = void 0;
// models/formFields.js
const globals_1 = require("models/globals");
exports.emailField = {
    view: "text", label: (0, globals_1._)("Identifiant"), name: "identifiant",
    id: "emailField", tooltip: (0, globals_1._)("ou votre adresse e-mail"),
    labelWidth: 130, labelAlign: "right",
    invalidMessage: (0, globals_1._)("L'identifiant ne peut être vide")
};
exports.motdepasseField = {
    view: "text", type: "password", label: (0, globals_1._)("Mot de passe"), name: "motdepasse",
    id: "motdepasseField",
    attributes: { maxlength: 24 },
    labelWidth: 130, labelAlign: "right", value: "",
    invalidMessage: (0, globals_1._)("Le mot de passe ne peut être vide")
};
